import React from 'react'
import Vertical from './Container'
import ResourceLoader from '../../../ResourceLoader'

const Wrapper = props =>
  <ResourceLoader reducers={ ['marketSpaces'] } epics={ ['marketSpaces'] }>
    <Vertical { ...props } />
  </ResourceLoader>

export default Wrapper
